module.exports = __webpack_public_path__ + "img/61_2.08fdc9fa.png";